// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__cF1xq"};